exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-text{text-align:center;font-family:Lato;font-weight:600;color:#3d3d3d;padding:0 .5rem}.checkout-button{font-size:1.5vh!important;border:none;border-radius:1vh;background-color:#0080fc;text-transform:uppercase;padding:14px 60px!important;color:#fff}.footer-btn{-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-297c7849","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/dashboard-v5/modal/CongratulationsWordPressPro.vue
// module id = Pqdb
// module chunks = 0